var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapActions } from 'vuex';
import { Const } from './provider/candle-history/lib/const.cls';
// import { ConstCache } from '@/plugins/vue-provider-cache/const.mod'
import * as Types from '../../types';
import { fxView } from './lib/fxView.cls';
import * as fxViewStoreExtensions from './provider/candle-history';
var state = __assign({}, fxViewStoreExtensions.stateExt);
var actions = __assign({}, fxViewStoreExtensions.actionsExt);
var mutations = __assign({}, fxViewStoreExtensions.mutationsExt);
var getters = __assign({}, fxViewStoreExtensions.gettersExt);
var fireabase_messaging;
var fireabase_SW = "";
var fxViewStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
var _store;
var intervalValue = null;
export var fxViewMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[fxView.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(fxView.STORE_MODULE_NAME, fxViewStore);
            }
            catch (error) { }
        }
        // this.intializeFirebase()
    },
    methods: __assign({}, mapActions({
        //get isin list
        _runGetIsinsList: Const.RUN_GET_ISINSLIST,
        _runChooseLiveDemo: Const.RUN_CHOOSE_DEMO_LIVE,
        _runRegisterEmailVerify: Const.RUN_REGISTER_EMAIL_VERIFY,
        _runRegisterSendEmailOtp: Const.RUN_SEND_EMAIL_OTP,
        _runGetSubscriptionDetail: Const.RUN_GET_SUBSCRIPTION_DETAIL,
        _runSaveuserToken: Types.SAVE_FIREBASE_TOKEN,
        _runLanguageApi: Const.RUN_LANGUAGE_API,
        _runBitcoinConversion: Const.RUN_BITCOIN_CONVERSION,
        //========================research & education=====================================
        _runGetWebinarData: Const.RUN_GET_WEBINAR_DATA,
        _runGetTutCourseCategory: Const.RUN_GET_TUT_COURSE_CATEGORY,
        _runGetVideoTutorial: Const.RUN_GET_VIDEO_TUTORIAL,
        _runGetPostData: Const.RUN_GET_POST_DATA,
        //=======================trading-tools=============================================
        _runGetAutochartistData: Const.RUN_GET_AUTOCHARTIST_DATA,
        _runGetSignalCentreData: Const.RUN_GET_SIGNAL_CENTRE_DATA,
        _runGetCurrentNews: Const.RUN_GET_CURRENT_NEWS,
        _runGetCurrentNewsDetails: Const.RUN_GET_CURRENT_NEWS_DETAIL,
        _runGetEconomicCalData: Const.RUN_GET_ECONOMIC_CALENDER_DATA,
        _runGetCalenderEvent: Const.RUN_GET_CALENDER_EVENT,
        _runGetAutoChartistWebUrl: Const.RUN_GET_AUTO_CHARTIST_WEB_URL,
        _runCouponPlan: Const.RUN_COUPON_PLAN,
        _runGetCouponList: Const.RUN_GET_COUPON_LIST,
        _runCheckCouponValidity: Const.RUN_CHECK_COUPON_VALIDITY,
        _runGetVpsList: Const.RUN_GET_VPS_LIST,
        _runGetVpsDetail: Const.RUN_GET_VPS_DETAIL,
        _runVpsRestart: Const.RUN_VPS_RESTART,
        _runVpsReboot: Const.RUN_VPS_REBOOT,
        _runVpsShutdown: Const.RUN_VPS_SHUTDOWN,
        _runVpsChangePassword: Const.RUN_VPS_CHANGE_PASSWORD,
        _runGetSubPlanList: Const.RUN_GET_SUB_PLAN_LIST,
        _runGetSubPlanDetail: Const.RUN_GET_SUB_PLAN_DETAIL,
        _runSubOperLink: Const.RUN_SUB_OPERATION_LINK,
        _runSubOperation: Const.RUN_SUB_OPERATION,
        _runCreateSubTicket: Const.RUN_CREATE_SUB_TICKET,
        _runLoaylitySubscriptionVerify: Const.RUN_LOYALITY_SUBSCRIP_VERIFY,
        _runUnsubService: Const.RUN_UNSUB_SERVICE,
        //=========================user=====================================================
        _runGetUserProfile: Const.RUN_GET_USER_PROFILE,
        _runUserNotification: Const.RUN_USER_NOTIFICATIONS,
        _runGetUserRegisterationStepData: Const.RUN_GET_USER_REGISTERATION_STEP_DATA,
        //========================trading accounts==========================================
        _runCreateAccount: Const.RUN_CREATE_ACCOUNT,
        _runCreateIBMamPammAccount: Const.RUN_CREATE_IB_MAM_PAMM_ACCOUNT,
        _runGetIbPdfName: Const.RUN_GET_IB_PDF_NAME,
        _runGetAccountHistory: Const.RUN_GET_ACCOUNT_HISTORY,
        _runCreateApiSubscription: Const.RUN_CREATE_API_SUBSCRIPTION,
        _runGetTradingAccountList: Const.RUN_GET_TRADING_ACCOUNT_LIST,
        _runAddLastSelectTradingAccount: Const.RUN_ADD_LAST_SELECT_TRADING_ACCOUNT,
        _runGetAccountDetails: Const.RUN_GET_TRADING_ACCOUNT_DETAILS,
        _runGetAccountPriorityList: Const.RUN_GET_ACCOUNT_PRIORITY_LIST,
        //========================manage accounts==========================================
        _runAccountPasswordRequestOtp: Const.RUN_ACCOUNT_PASSWORD_REQUEST_OTP,
        _runAccountPasswordCheckOtp: Const.RUN_ACCOUNT_PASSWORD_CHECK_OTP,
        _runAccountLeverageCheckOtp: Const.RUN_ACCOUNT_LEVERAGE_CHECK_OTP,
        _runInternalTransferCheckOtp: Const.RUN_INTERNAL_TRANSFER_CHECK_OTP,
        _runResendEmailLinkAccount: Const.RUN_RESEND_EMAIL_LINK_ACCOUNTS,
        _runAmountConversionApi: Const.RUN_AMOUNT_CONVERSION_API,
        //======================support=======================================================
        _runGetTicketList: Const.RUN_GET_TICKET_LIST,
        _runGetTicketDetail: Const.RUN_GET_TICKET_DETAIL,
        _runTicketRequestOtp: Const.RUN_TICKET_REQUEST_OTP,
        _runTicketCheckOtp: Const.RUN_TICKET_CHECK_OTP,
        _runTicketReply: Const.RUN_TICKET_REPLY,
        _runGetTicketReasonList: Const.RUN_GET_TICKET_REASON_LIST,
        _runTicketResendOtp: Const.RUN_TICKET_RESEND_OTP,
        _runRequestCallback: Const.RUN_REQUEST_CALLBACK,
        //==================================deposit=========================================
        _runGetDepositList: Const.RUN_GET_DEPOSIT_LIST,
        _runGetDepositListFTD: Const.RUN_GET_DEPOSIT_LIST_FTD,
        _runTransactionLimitCurrency: Const.RUN_TRANS_LIMIT_CURRENCY,
        _runDemoDeposit: Const.RUN_DEMO_DEPOSIT,
        _runGetUserCanDeposit: Const.RUN_GET_USER_CAN_DEPOSIT,
        _runCreditCardDeposit: Const.RUN_CREDIT_CARD_DEPOSIT,
        _runKorapayDeposit: Const.RUN_KORAPAY_DEPOSIT,
        _runKorapayCurrency: Const.RUN_KORAPAY_CURRENCY_LIST,
        _runCryptoDeposit: Const.RUN_CRYPTO_DEPOSIT,
        _runGetTransactionStatus: Const.RUN_GET_TRANSACTION_STATUS,
        _runPraxisUrl: Const.RUN_GET_PRAXIS_URL,
        //==================================bank=========================================
        _runAddBank: Const.RUN_ADD_BANK,
        _runGetBankList: Const.RUN_GET_BANK_LIST,
        //==================================withdrawal========================================
        _runGetWithdrawalList: Const.RUN_GET_WITHDRAWAL_LIST,
        _runWithdrawalRequestOtp: Const.RUN_WITHDRAWAL_REQUEST_OTP,
        _runWithdrawalCheckOtp: Const.RUN_WITHDRAWAL_CHECK_OTP,
        _runResendEmailLink: Const.RUN_RESEND_EMAIL_LINK,
        _runGetWithdrawalMethods: Const.RUN_GET_WITHDRAWAL_METHODS,
        _runGetWithdrawalDesc: Const.RUN_GET_WITHDRAWAL_DESC,
        //=============================bonus===================================================
        _runTradingBonus: Const.RUN_TRADING_BONUS,
        _runBonusRequestOtp: Const.RUN_BONUS_REQUEST_OTP,
        _runBonusCheckOtp: Const.RUN_BONUS_CHECK_OTP,
        _runResendEmailLinkBonus: Const.RUN_RESEND_EMAIL_LINK_BONUS,
        _runGetBonusList: Const.RUN_GET_BONUS_LIST,
        _runRemoveBonus: Const.RUN_REMOVE_BONUS,
        //===================static variable fetch from database============================
        _runGetCountriesList: Const.RUN_GET_COUNTRIES_LIST,
        _runGetCitiesList: Const.RUN_GET_CITIES_LIST,
        //===================Dashboard charts===============================================
        _runGetProfitData: Const.RUN_GET_PROFIT_CHART_DATA,
        _runGetBalanceData: Const.RUN_GET_BALANCE_DATA,
        _runGetEquityData: Const.RUN_GET_EQUITY_DATA,
        _runGetTradingData: Const.RUN_GET_TRADING_DATA,
        _runGetIdenfyToken: Const.RUN_GET_IDENFY_TOKEN,
        _runRefferFriend: Const.RUN_REFER_Friend,
        _runGetRefferList: Const.RUN_GET_REFER_LIST,
        _runRefferDelete: Const.RUN_REFER_DELETE,
        _runGetAutochartistUrl: Const.RUN_GET_AUTOCHARTIST_URL,
        _runConverWallettBallence: Const.RUN_CONVERT_WALLET_BALANCE,
        _runGetHoopsData: Const.RUN_GET_HOOPS_DATA,
        //wallet
        _runCreateWalletAccount: Const.RUN_CREATE_WALLET_ACCOUNT,
        _runGetWalletDetail: Const.RUN_GET_WALLET_DETAIL,
        _runGetWalletTransaction: Const.RUN_GET_WALLET_TRANSACTION,
        _runGetWalletBalance: Const.RUN_GET_WALLET_BALANCE,
        _runGetSwiffyDetail: Const.RUN_SWIFFY_DETAILS,
        _runGetHelp2PaymenyInfo: Const.RUN_HELP2PAY_PAYMENTINFO,
        _runGetHelp2PayDetail: Const.RUN_HELP2PAY_DETAILS,
        // _runGetHelp2CurrencyConversion 				:   		Const.RUN_HELP2PAY_CURRENCY_CONVERSION,
        _runGetPayguruDetail: Const.RUN_PAYGURU_DETAILS,
        _runGetAllCurrencyList: Const.RUN_ALL_CURRENCY_LIST,
        // Vertupay 
        _runGetVertuPayDetail: Const.RUN_VERTUPAY_DETAILS,
        //Astropay
        _runGetAstroPayDetail: Const.RUN_ASTROPAY_DETAILS,
        //Perfect Money
        _runGetPerfectMoneyDetail: Const.RUN_PERFECT_MONEY_DETAILS,
        //Nuvei Payment
        _runGetNuveiDetail: Const.RUN_NUVEI_DETAILS,
        //TrustPay Payment
        _runGetTrustPayDetail: Const.RUN_GET_TRUST_PAY_DETAILS,
        //Payment Asia
        _runGetPaymentAsiaDetail: Const.RUN_GET_PAYMENTASIA_DETAILS,
        //loyality points
        _runGetLoyalityCardDetail: Const.RUN_GET_LOYALITY_CARD_DETAIL,
        _runGetLoyalityTxnList: Const.RUN_GET_LOYALITY_TXN_LIST,
        _runLoyalityRequestOtp: Const.RUN_LOYALITY_REQUEST_OTP,
        _runLoyalityRedeemCheckOtp: Const.RUN_LOYALITY_REDEEM_CHECK_OTP,
        _runLoyalityTransaferCheckOtp: Const.RUN_LOYALITY_TRANSFER_CHECK_OTP,
        _runLoyalityResendOtp: Const.RUN_LOYALITY_EMAIL_VERIFY_LINK,
        //subsctiption update
        _runSubscriptionRequestOtp: Const.RUN_SUBSCRIPTION_REQUEST_OTP,
        _runSubscriptionCheckOtp: Const.RUN_SUBSCRIPTION_CHECK_OTP,
        _runSubscriptionResendEmailLink: Const.RUN_SUBSCRIPTION_RESEND_EMAIL_LINK,
        //unsubscribe
        _runUnsubscribeRequestOtp: Const.RUN_UNSUBSCRIBE_REQUEST_OTP,
        _runUnsubscribeCheckOtp: Const.RUN_UNSUBSCRIBE_CHECK_OTP,
        _runUnsubscribeResendEmailLink: Const.RUN_Unsubscribe_RESEND_EMAIL_LINK,
        _runBankDepositForFewCountries: Const.RUN_BANK_DEPOSIT_FOR_FEW_COUNTRIES,
        //notifications			 
        _runGetNotificationList: Const.RUN_GET_NOTIFICATION_LIST,
        _runReadUnreadNotification: Const.RUN_READ_UNREAD_NOTIFICATION,
        _runGetCryptoMethod: Const.RUN_GET_CRYPTO_Methods,
        _runAddCryptoMethod: Const.RUN_ADD_CRYPTO_Methods,
        _runUpdateFirstDeposit: Const.RUN_UPDATE_FIRST_DEPOSIT,
        //cancel withdrawal request
        _runCancelWithdrawalRequest: Const.RUN_CANCEL_WITHDRAWAL_REQUEST,
        _runAstropayAffiliateLogin: Const.RUN_ASTROPAY_AFFILIATE_LOGIN,
        _runAstropayCurrencyConversion: Const.RUN_ASTROPAY_CURRENCY_CONVERSION,
    }), { handleValidationErrorAdvanced: function (getErrors) {
            try {
                var firstField = Object.keys(getErrors.collect())[0];
                this.$refs[firstField + "Input"].focus();
                return this.$refs[firstField + "Input"].scrollIntoView();
            }
            catch (e) { }
        },
        redirect: function () {
            this.$router.replace({ name: "fxView.support", params: { tabName: 'openRequest', page: 'view_dash' } });
        }, 
        // redirect() {
        // 	// Filter for 'Proof of Identity' and 'Proof of Residence'
        // 	const documents = this.get_user.profile.documents.filter(doc => 
        // 		doc.document_type === 'Proof of Identity' || doc.document_type === 'Proof of Residence'
        // 	);
        // 	// Check if 'Proof of Identity' exists
        // 	const hasProofOfIdentity = documents.some(doc => doc.document_type === 'Proof of Identity');
        // 	// Check if 'Proof of Residence' exists
        // 	const hasProofOfResidence = documents.some(doc => doc.document_type === 'Proof of Residence');
        // 	if (hasProofOfIdentity && hasProofOfResidence) {
        // 		console.log("1 ===");
        // 		this.$router.replace({ name: "fxView.support", params: { tabName: 'openRequest', page: 'view_dash' } });
        // 	} else if (hasProofOfResidence) {
        // 		console.log("2 ===");
        // 		this.$router.replace({ name: "fxView.step_five" });
        // 		// this.$router.replace({ name: "fxView.support", params: { tabName: 'openRequest', page: 'view_dash' } });
        // 	}
        // },
        numberWithCommas: function (x) {
            if (x == undefined) {
                x = 0;
            }
            var negative = "";
            if (x < 0) {
                negative = '-';
            }
            x = parseFloat(x).toFixed(2);
            x = Math.abs(x);
            x = x.toString();
            var afterPoint = '';
            if (x.indexOf('.') > 0)
                afterPoint = x.substring(x.indexOf('.'), x.length);
            x = Math.floor(x);
            x = x.toString();
            var lastThree = x.substring(x.length - 3);
            var otherNumbers = x.substring(0, x.length - 3);
            if (otherNumbers != '')
                lastThree = ',' + lastThree;
            return negative + otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
        }, computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        },
        stepPageOpenFunc: function (getStep) {
            // let step = '/step' + (parseInt(this.get_user.step) + 1)
            // return step;
            // Logic to compute the route based on the step
            var getliveAccount = sessionStorage.getItem('account_detail');
            var isLiveStatus = (this.get_user.profile.account.filter(function (acc) { return parseInt(acc.demo_live) == 1; }) || []).length;
            this.tradeAcc = JSON.parse(getliveAccount || '{}');
            // const { verified_status } = this.get_user;
            // const verified_sts = parseInt(verified_status);
            var hasSumsub_applicantId = this.get_user.profile.sumsub_applicantId.hasSumsub_applicantId;
            var demo_live = this.tradeAcc.demo_live;
            if (getStep == 0) {
                return '/step' + 1;
            }
            else if (getStep == 1) {
                return '/step' + 2;
            }
            else if (!isLiveStatus && !demo_live && (getStep >= 2)) {
                return '/step' + 3;
            }
            else if (isLiveStatus == 1 || getStep >= 2 && parseInt(demo_live) == 1) {
                console.log("step5", getStep >= 2 && parseInt(demo_live) == 1);
                return '/step' + 5;
            }
            else if (getStep == 4 && hasSumsub_applicantId == '') {
                // console.log("step =======++", getStep == 4 && hasSumsub_applicantId == '')
                return '/step' + 5;
            }
        },
        serviceFunction: function (planId, detailId, clickEvent) {
            var sub_array = this.get_user.profile.subscriptions, count = 0, id;
            if (detailId != '' && detailId != null) {
                if (sub_array.length > 0) {
                    for (var i = 0; i <= sub_array.length - 1; i++) {
                        if ((parseInt(sub_array[i].plan_id) == parseInt(planId)) && (parseInt(sub_array[i].pdetail_id) == parseInt(detailId))) {
                            count = 1;
                            if (clickEvent != '' && clickEvent != null && clickEvent != undefined) {
                                id = sub_array[i].id;
                            }
                        }
                        if (i == sub_array.length - 1) {
                            if (count == 1) {
                                if (clickEvent != '' && clickEvent != null && clickEvent != undefined) {
                                    this.unsubscribe1(id);
                                }
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                }
                else {
                    return false;
                }
            }
            else {
                if (sub_array.length > 0) {
                    var count1 = 0;
                    for (var j = 0; j <= sub_array.length - 1; j++) {
                        if (parseInt(sub_array[j].plan_id) == parseInt(planId)) {
                            count1 = 1;
                        }
                        if (j == sub_array.length - 1) {
                            if (count1 == 1) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }
                    }
                }
                else {
                    return true;
                }
            }
        },
        reaskPermission: function () {
            var permission;
            if ('Notification' in window) {
                permission = Notification.permission;
                return permission;
            }
            else {
                return false;
            }
        },
        formatDecimal: function (getdata) {
            if (getdata) {
                getdata = parseFloat(getdata).toFixed(2);
                return getdata;
            }
            else {
                return getdata;
            }
        },
        checkROll: function (module) {
            if (module === void 0) { module = ''; }
            var rollList = this.$store.getters[Types.GET_USER];
            rollList = rollList.roles.split('&');
            var cases = {
                'deposits': function () { return rollList.includes('BL') || rollList.includes('BL-D'); },
                'withdrawals': function () { return rollList.includes('BL') || rollList.includes('BL-W'); },
            };
            return !cases[module]();
        } }),
    computed: {
        astroPayCountryMethods: function () { return this.computedCommonFunc(Const.GET_ASTROPAY_METHODS); },
        notificationList: function () { return this.computedCommonFunc(Const.GET_NOTIFICATION_LIST); },
        european_countries_list: function () { return this.computedCommonFunc(Const.GET_EUROPEAN_COUNTRY_LIST); },
        getHelp2PayBankList: function () { return this.computedCommonFunc(Const.GET_HELP2PAY_BANK_LIST); },
        getVertupayList: function () { return this.computedCommonFunc(Const.GET_VERTUPAY_BANK_LIST); },
        nuveiData: function () { return this.computedCommonFunc(Const.GET_NUVEI_DETAILS); },
        amountLimit: function () { return this.computedCommonFunc(Const.GET_HELP2PAY_AMOUNT_LIMIT); },
        vtpAmountLimit: function () { return this.computedCommonFunc(Const.GET_VERTUPAY_AMOUNT_LIMIT); },
        countryCurrency: function () { return this.computedCommonFunc(Const.GET_COUNTRY_CURRENCY); },
        vtpCountryCurrency: function () { return this.computedCommonFunc(Const.GET_VTP_COUNTRY_CURRENCY); },
        notificationUnreadList: function () { return this.computedCommonFunc(Const.GET_UNREAD_NOTIFICATION_DATA); },
        referList: function () { return this.computedCommonFunc(Const.GET_REFER_LIST); },
        videoTutorial: function () { return this.computedCommonFunc(Const.GET_VIDEO_TUTORIAL); },
        formDisplayVar: function () { return this.computedCommonFunc(Const.GET_CHANGE_ACCOUNT_DATA_FORM_FORM_DISPLATY); },
        zuluAccountList: function () { return this.computedCommonFunc(Const.GET_ZULU_ACCOUNT_LIST); },
        ibMamPammAccountList: function () { return this.computedCommonFunc(Const.GET_IB_MAM_PAMM_ACCOUNT_LIST); },
        getSubscriptionDetail: function () { return this.computedCommonFunc(Const.GET_SUBSCRIPTION_DETAIL); },
        //loyality
        loyalityCardDetail: function () { return this.computedCommonFunc(Const.GET_LOYALITY_CARD_DETAIL); },
        loyalityCardTxn: function () { return this.computedCommonFunc(Const.GET_LOYALITY_CARD_TXN); },
        loyalityLastCredit: function () { return this.computedCommonFunc(Const.GET_LOYALITY_LAST_CREDIT); },
        //wallet
        walletblnce: function () { return this.computedCommonFunc(Const.GET_WALLET_BALANCE); },
        allAccountList: function () { return this.computedCommonFunc(Const.GET_ALL_ACCOUNT_LIST); },
        walletAccount: function () { return this.computedCommonFunc(Const.GET_WALLET_ACCOUNT); },
        walletTransaction: function () { return this.computedCommonFunc(Const.GET_WALLET_TRANSACTION); },
        walletCurrencyData: function () { return this.computedCommonFunc(Const.GET_WALLET_CURRENCY_DATA); },
        //trading-tool
        hoopsData: function () { return this.computedCommonFunc(Const.GET_HOOPS_DATA); },
        signalCentre: function () { return this.computedCommonFunc(Const.GET_SIGNAL_CENTRE); },
        autoChartist: function () { return this.computedCommonFunc(Const.GET_AUTO_CHARTIST); },
        currentNews: function () { return this.computedCommonFunc(Const.GET_CURRENT_NEWS); },
        newsDetail: function () { return this.computedCommonFunc(Const.GET_CURRENT_NEWS_DETAIL); },
        economicCalData: function () { return this.computedCommonFunc(Const.GET_ECONOMIC_CALENDER_DATA); },
        subPlanList: function () { return this.computedCommonFunc(Const.GET_SUB_PLAN_LIST); },
        subPlanDetail: function () { return this.computedCommonFunc(Const.GET_SUB_PLAN_DETAIL); },
        vpsList: function () { return this.computedCommonFunc(Const.GET_VPS_LIST); },
        vpsDetail: function () { return this.computedCommonFunc(Const.GET_VPS_DETAIL); },
        //user
        get_user: function () { return this.computedCommonFunc(Types.GET_USER); },
        convertedCurrencies: function () { return this.computedCommonFunc(Types.GET_CONVERSION_CURRENCY); },
        getUserProfile: function () { return this.computedCommonFunc(Const.GET_USER_PROFILE); },
        country_tax_residence_nationality: function () { return this.computedCommonFunc(Const.GET_COUNTRY_TAX_RESIDENCE_NATIONALITY); },
        userNotify: function () { return this.computedCommonFunc(Const.GET_USER_NOTIFICATIONS); },
        countriesList: function () { return this.computedCommonFunc(Const.GET_COUNTRIES_LIST); },
        citiesList: function () { return this.computedCommonFunc(Const.GET_CITIES_LIST); },
        empStatus: function () { return this.computedCommonFunc(Const.GET_EMP_STATUS); },
        occupationList: function () { return this.computedCommonFunc(Const.GET_OCCUPATION); },
        educationList: function () { return this.computedCommonFunc(Const.GET_EDUCATION); },
        estYearlyIncome: function () { return this.computedCommonFunc(Const.GET_EST_YEARLY_INCOME); },
        source_of_funds: function () { return this.computedCommonFunc(Const.GET_SOURCE_OF_FUNDS); },
        estNetWorth: function () { return this.computedCommonFunc(Const.GET_EST_NET_WORTH); },
        antAccountTurnover: function () { return this.computedCommonFunc(Const.GET_ANT_ACCOUNT_TURNOVER); },
        tinsynom: function () { return this.computedCommonFunc(Const.GET_TIN_PASSPORT_OPTION); },
        couponList: function () { return this.computedCommonFunc(Const.GET_COUPON_LIST); },
        //CRS & MiFir
        // tinsynom : function(){ return this.computedCommonFunc(Const.CRSNUMBER); },
        //trading accounts
        lastSelectTradingAccount: function () { return this.computedCommonFunc(Const.GET_LAST_SELECT_TRADING_ACCOUNT); },
        tradingAccountList: function () { return this.computedCommonFunc(Const.GET_TRADING_ACCOUNT_LIST); },
        liveAccountList: function () { return this.computedCommonFunc(Const.GET_LIVE_ACCOUNT_LIST); },
        demoAccountList: function () { return this.computedCommonFunc(Const.GET_DEMO_ACCOUNT_LIST); },
        accountDetails: function () { return this.computedCommonFunc(Const.GET_ACCOUNT_DETAILS); },
        //deposit
        depositList: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIST); },
        deposit_limit: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIMIT); },
        //withdrawal
        withdrawalList: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_LIST); },
        withdrawalMethodResponse: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE); },
        withdrawalMethodResponseDep: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP); },
        //bonus
        bonusList: function () { return this.computedCommonFunc(Const.GET_BONUS_LIST); },
        //support
        ticketData: function () { return this.computedCommonFunc(Const.GET_TICKET_DATA); },
        ticketList: function () { return this.computedCommonFunc(Const.GET_TICKET_LIST); },
        ticketView: function () { return this.computedCommonFunc(Const.GET_TICKET_VIEW); },
        ticketReasonList: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON_LIST); },
        reasonList: function () { return this.computedCommonFunc(Const.GET_REASON_LIST); },
        //bank
        bankListData: function () { return this.computedCommonFunc(Const.GET_BANK_LIST); },
        entityData: function () { return this.computedCommonFunc(Const.GET_ENTITY_DATA); },
    }
};
export default fxViewMixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/index.ts
// module id = null
// module chunks = 